import { render, staticRenderFns } from "./DepartmentTableRow.vue?vue&type=template&id=36fda502"
import script from "./DepartmentTableRow.vue?vue&type=script&lang=js"
export * from "./DepartmentTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports